module.exports = __webpack_public_path__ + "img/pantalla-7-1-mobile.fbb8393e.png";